import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import { CheckBox, StatusWarning } from '_components';
import styles from './Common.module.css';


class AlTemplateTherExRow extends React.Component {

    render() {
        return (
            <div className={styles.row}>
                <CheckBox
                    size='extra-small'
                    className={styles.checkbox}
                    checked={this.props.activity.selected}
                    title={this.props.desc}
                    label={this.props.desc}
                    onClick={() => this.props.toggleItem({ entity: 'MLTMPTHEREX', entityKeyColumn: 'XLTMPTENO', entityKeyValue: this.props.activity.XLTMPTENO })}
                />
                { !this.props.activity.valid &&
                    <span className={styles.warning}>
                        <StatusWarning size='extra-small' title='Not Reimbursable based on Payer/Contract' />
                    </span>
                }
            </div>
        );
    }

}

function mapDispatchToProps(dispatch) {
    return {
        toggleItem: bindActionCreators(noteActions.alTemplateToggleItem, dispatch)
    };
}

function mapStateToProps(state, ownprops) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let activity = state.entities.notes.MLTMPTHEREX[ownprops.id];
    let tename = activity.XLTMPTETENO ? state.entities.masterData.MLMASTERTHEREX[activity.XLTMPTETENO].TENAME + ' - ' : '';
    let act = activity.XLTMPTEACTIVITY ? activity.XLTMPTEACTIVITY + ' - ' : '';
    let setsReps = activity.XLTMPTESETSREPS ? activity.XLTMPTESETSREPS + ' - ' : '';
    let desc = tename + act + setsReps;
    desc = desc.endsWith(' - ') ? desc.slice(0, -3) : desc;

    return {
        noteId: noteId,
        activity: activity,
        desc: desc
    };
}

const connectedAlTemplateTherExRow = connect(mapStateToProps, mapDispatchToProps)(AlTemplateTherExRow);
export { connectedAlTemplateTherExRow as AlTemplateTherExRow };

